import React, { useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import "./initiatives-accordion.scss";

import { InitiativeAccordionItem } from "./InitiativeAccordionItem";
import { useDispatch } from "react-redux";
import {
  LightText,
  SmallBoldText,
  SmallLightText,
  SmallNormalText,
} from "../../../../../utils/typographyUtils";
import { MousePointer, PlusIcon } from "lucide-react";
import StandardButton from "../../../../shared/formComponents/StandardButton/StandardButton";
import ButtonIcon from "../../../../shared/formComponents/StandardButton/ButtonIcon";
import { ConditionalRender } from "../../../../shared/ConditionalRender/ConditionalRender";

export const InitiativesAccordion = ({
  initiatives,
  isViewMode,
  objectiveId,
  showOnHoverText,
  callBack,
  disableProgress,
  isPlanPublished,
  expandedItem,
  showDeleteKeyResultPopup,
  itemData,
  editMode,
  expandedObjective,
  disableOperations,
  closeAllAccordions,
  showActions,
}) => {
  const [showInitiativeInput, setShowInitiativeInput] = useState({
    show: false,
    type: "",
  });
  const [initiativesData, setInitiativesData] = useState(initiatives);
  const [initiative, setInitiative] = useState("");
  const dispatch = useDispatch();
  const [isExpanded, setIsExpanded] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [showDeleteInitiativePopup, setShowDeleteInitiativePopup] = useState({
    show: false,
    id: "",
  });

  const handleShowOnHoverText = () => {
    if (showOnHoverText) {
      return (
        <div className="bg-white rounded py-1 w-auto px-2 me-3">
          <SmallLightText>
            <MousePointer
              fill="#656565"
              className="me-2"
              height={16}
              width={16}
            />
            Hover over an Initiative to edit or delete
          </SmallLightText>
        </div>
      );
    }
    return null;
  };
  const handleUpdateInitiativePercentage = (index, key, value) => {
    let tempInits = JSON.parse(JSON.stringify(initiatives));
    tempInits[index][key] = value;
    initiatives = tempInits;
  };
  const renderEmptyState = () => {
    return (
      <div className={"mt-2"}>
        <LightText>
          There were no initiatives added in this objective.
        </LightText>
      </div>
    );
  };
  return (
    <div className={`initiatives-accordion  ${isExpanded ? "open" : ""}`}>
      <div
        onClick={() => setIsExpanded(!isExpanded)}
        className={`d-flex align-items-center cursor-pointer initiative-item-header ${
          isExpanded
            ? "pb-2 px-3 py-2 initiatives-accordion-item-header-active"
            : "p-3"
        }`}
      >
        <div className="d-flex align-items-center w-100">
          <img src={`/assets/images/initiatives.svg`} className="me-2" />
          <SmallBoldText>
            Initiatives{" "}
            <LightText classNames={"font-weight-normal"}>
              ({initiativesData.length})
            </LightText>
          </SmallBoldText>
          <ConditionalRender condition={showActions && isExpanded}>
            <div>
              <StandardButton
                text="Add"
                color="btn-outline-brand-blue-new"
                className="ms-3 py-1"
                reversed
                icon={
                  <ButtonIcon
                    icon={PlusIcon}
                    size={16}
                    viewBox="0 0 24 26"
                    height={16}
                    width={16}
                  />
                }
                disabled={true}
              />
            </div>
          </ConditionalRender>
        </div>
        <div className="d-flex w-50 justify-content-end">
          <ConditionalRender condition={isExpanded}>
            {handleShowOnHoverText()}
          </ConditionalRender>
          <img
            className="cursor-pointer"
            onClick={() => setIsExpanded(!isExpanded)}
            src={`/assets/images/${
              isExpanded ? "up-arrow.svg" : "down-arrow.svg"
            }`}
          />
        </div>
      </div>
      <div
        className={`initiatives-accordion-item-body px-3  ${
          isExpanded ? "open py-2" : ""
        }`}
      >
        {initiativesData.length === 0 && !showInitiativeInput.show ? (
          <div className="text-center">{renderEmptyState()}</div>
        ) : (
          <div className="border rounded pt-3 pb-1">
            <div className="border-bottom">
              <div className="row px-3 pb-1">
                <div className={`col-9 d-flex`}>
                  <SmallNormalText classNames={"me-4 key-result-text"}>
                    #
                  </SmallNormalText>
                  <SmallNormalText classNames={"key-result-text"}>
                    Initiative Name
                  </SmallNormalText>
                </div>
                <ConditionalRender condition={isPlanPublished}>
                  <div className={`col-3 d-flex`}>
                    <SmallNormalText classNames={"key-result-text"}>
                      Progress
                    </SmallNormalText>
                  </div>
                </ConditionalRender>
              </div>
            </div>
            <div className="py-2">
              {initiativesData.map((initiative, index) => {
                return (
                  <InitiativeAccordionItem
                    key={initiative.initiativeId}
                    isViewMode={isViewMode}
                    buttonDisabled={buttonDisabled}
                    isLastItem={isPlanPublished && initiativesData.length === 1}
                    showInitiativeInput={showInitiativeInput}
                    setShowInitiativeInput={setShowInitiativeInput}
                    index={index}
                    disableOperations={disableOperations}
                    hideProgressBar={disableProgress}
                    editMode={editMode}
                    setShowDeleteInitiativePopup={setShowDeleteInitiativePopup}
                    showDeleteInitiativePopup={showDeleteInitiativePopup}
                    intiativeItem={initiative}
                    showActions={showActions}
                  />
                );
              })}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
